import * as React from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Checkbox,
  CircularProgress,
  Collapse,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  List,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  styled,
  tableCellClasses,
  Box,
  FormControlLabel,
  Grid,
  Link,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PortalSigninForm } from "./Common/PortalSigninForm";
import { PortalSignupForm } from "./Common/PortalSignupForm";

interface PortalLoginProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PortalLogin: React.FunctionComponent<PortalLoginProps> = (
  props
) => {
  const [activePage, setActivePage] = React.useState<"signin" | "signup">(
    "signin"
  );
  return (
    <Dialog open={props.isOpen} onClose={() => {}} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "right",
          alignItems: "center",
          padding: 1,
          paddingBottom: 0,
        }}
      >
        <IconButton onClick={props.onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ paddingTop: 0, paddingBottom: 0 }}>
        {activePage === "signin" ? (
          <PortalSigninForm></PortalSigninForm>
        ) : (
          <PortalSignupForm></PortalSignupForm>
        )}

        <Grid container mb={3}>
          <Grid item xs></Grid>
          <Grid item>
            {activePage === "signin" ? (
              <Link
                href="#"
                variant="body2"
                onClick={(e) => {
                  e.preventDefault();
                  setActivePage("signup");
                }}
              >
                {"Don't have an account? Sign Up"}
              </Link>
            ) : (
              <Link
                href="#"
                variant="body2"
                onClick={(e) => {
                  e.preventDefault();
                  setActivePage("signin");
                }}
              >
                {"Already have an account? Sign in"}
              </Link>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
